import { Box } from "@mui/material";
import NavBar from "../Utilities/NavBar";
import FilterTab from "../Utilities/FilterTab";
import SocialPostCard from "./Utilities/SocialPostCard";

export default function SocialPosts() {
  return (
    <Box sx={{ backgroundColor: "#EDEDE4" }}>
      <NavBar />
      <Box sx={styles.root}>
        <Box sx={styles.container}>
          <Box sx={styles.bodyWrapper}>
            <FilterTab withMsgStatus={false} />
            <Box sx={{ flex: "1" }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Box component={"h1"} sx={styles.headingText}>
                  Social Posts
                </Box>

                <Box
                  component={"p"}
                  sx={{
                    color: "#6b746b",
                    fontFamily: "FustatRegular",
                    fontSize: "14px",
                    m: 0,
                  }}
                >
                  Organic & paid · newest first
                </Box>
              </Box>

              <Box
                sx={{
                  mt: 2,
                  display: "grid",
                  gridTemplateColumns: {
                    xs: "1fr",
                    sm: "1fr 1fr",
                    md: "1fr 1fr 1fr",
                  },
                  gap: "20px",
                }}
              >
                <SocialPostCard />
                <SocialPostCard />
                <SocialPostCard />
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

const styles = {
  root: {
    pt: 4,
    minHeight: "100vh",
    pb: 10,
  },
  container: {
    px: { xs: 2, sm: 4, md: 6 },
    width: "100%",
    maxWidth: "1440px",
    position: "relative",
    mx: "auto",
  },
  bodyWrapper: {
    display: "flex",
    gap: 4,
    alignItems: "flex-start",
    position: "relative",
  },
  headingText: {
    m: 0,
    fontFamily: "FustatBold",
    fontSize: 30,
    lineHeight: 1.2,
    letterSpacing: "-0.02em",
    color: "#0C2728",
  },
};
